import {graphql} from '~/graphql-react-query/';

export const ApiTokenListQuery = graphql(`
    query ApiTokenListQuery($input: ApiTokenListInput!) {
        apiToken {
            apiTokenList(input: $input) {
                id
                name
                createdAt
                expiresAt
                revokedAt
                scopes {
                    __typename
                    ... on CreativeAndMediaValueScope {
                        product
                        country
                    }
                    ... on ComplianceScope {
                        product
                        country
                    }
                }
            }
        }
    }
`);

export const ApiTokenCreateMutation = graphql(`
    mutation ApiTokenCreateMutation($input: CreateApiTokenInput!) {
        apiToken {
            createApiToken(input: $input) {
                id
                name
                apiToken
                createdAt
                expiresAt
                revokedAt
                scopes {
                    __typename
                    ... on CreativeAndMediaValueScope {
                        product
                        country
                    }
                    ... on ComplianceScope {
                        product
                        country
                    }
                }
            }
        }
    }
`);

export const ApiTokenRevokeMutation = graphql(`
    mutation ApiTokenRevokeMutation($input: RevokeApiTokenInput!) {
        apiToken {
            revokeApiToken(input: $input) {
                id
                name
                createdAt
                expiresAt
                revokedAt
            }
        }
    }
`);
